// 婚纱摄影子分类 - 旅拍
export const LV_PAI = 4
